import { sortByOrder } from '../../../provider/utility';

export const convertWorkshopLevelsToRobotAccordion = (wsLevels) =>
  sortByOrder(
    wsLevels.map((lvl) => ({
      ...lvl,
      type: 'robot',
      value: lvl.id,
      title: lvl.name,
    })),
  );

export const filterByAge = (wsLevels, age) =>
  wsLevels.filter((robot) =>
    robot.age_int?.length > 0 ? robot.age_int.includes(age) : true,
  );
